<template>
	<input
		type="tel"
		class="afizo22"
		:class="[size, status]"
		:value="value"
		@focus="$emit('focus')"
		@blur="onBlur($event.target.value)"
		@input="onInput($event.target.value)"
		@keyup.enter="$emit('enter')"
		:data-fup="`input/${id}`"
		:disabled="isReadOnly"
	/>
</template>

<script>
export default {
	name: "j-base-input-number",
	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return (
					val === null || typeof val === "string" || typeof val === "number"
				)
			}
		},
		type: {
			required: false,
			default: "float", // integer or float
			validator(val) {
				return val === null || ["integer", "float"].includes(val)
			}
		},
		// TODO: allow negative numbers
		allowNegative: {
			required: false,
			default: false,
			type: Boolean
		},
		max: {
			type: Number,
			required: false
		},
		min: {
			type: Number,
			required: false
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return val === null || ["error", "success", "warning"].includes(val)
			}
		},
		id: {
			type: String,
			required: false,
			default: ""
		},
		isReadOnly: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		// TODO: add more types - float, negative
		onInput(value) {
			// Positive int
			if (this.type === "integer") {
				// Remove all not allowed symbols
				value = value.replace(/[^\d]/gi, "")

				// Parse to number
				value = parseInt(value)
			}
			// Positive float
			else if (this.type === "float") {
				// Remove all not allowed symbols
				value = value.replace(/[^0-9\.]+/gi, "")
			}

			value = this.type === "integer" ? parseInt(value) : value // check only for int as float will break when number is not completed
			value = isNaN(value) ? null : value

			// If max/min
			if (this.max && this.max < value) value = this.max
			if (this.min && this.min > value) value = this.min

			this.$emit("input", value)

			// NOTE: when value is the same, component won't update when $emit
			// and thus input value is not changed so we have to forceUpdate the component everytime
			this.$forceUpdate()
		},

		onBlur(value) {
			if (this.type === "float") {
				value = parseFloat(value)
				value = isNaN(value) ? null : value
			}

			this.$emit("input", value)

			// Also emit blur event
			this.$emit("blur")
		}
	}
}
</script>
<style src="./index.css" scoped />
